<template lang="html">
  <div class="container-pad">
    <rare-home-products-crs :isHeader="true" @jumpToForm="jumpToForm" />

    <home-products-crs-data-row />

    <rare-comparison-table
      :headers="tableHeaders"
      :rows="tableRows"
    />

    <testimonial-carousel
      :slides="slides"
    />

    <home-products-crs-main-section />

    <home-products-crs-logos />

    <rare-contact-form :product="'CRS'" />

    <rare-awards/>
  </div>
</template>

<script>

import Mary from '@/assets/img/photos/testimonials/crs/Mary.png';
import Christina from '@/assets/img/photos/testimonials/crs/Christina.png';
import Skye from '@/assets/img/photos/testimonials/crs/Skye.png';
import Hannah from '@/assets/img/photos/testimonials/crs/Hannah.png';

import HSF from '@/assets/img/logos/testimonial-logos/hsf.png';
import Dentons from '@/assets/img/logos/testimonial-logos/dentons.png';
import Womble from '@/assets/img/logos/testimonial-logos/womble.png';
import FrankKnight from '@/assets/img/logos/testimonial-logos/frankknight.png';

import RareContactForm from '../../../components/forms/RareContactForm';
import RareAwards from '../../../components/carousels/awardsCarousel';
import RarePersonQuote from '../../../components/commonSections/RarePersonQuote';
import RareComparisonTable from '../../../components/commonSections/RareComparisonTable';
import HomeProductsCrsDataRow from './components/HomeProductsCrsDataRow';
import RareHomeProductsCRS from '../components/RareHomeProductsCRS';
import HomeProductsCrsLogos from './components/homeProductsCrsLogos';
import HomeProductsCrsMainSection from './components/homeProductsCrsMainSection';
import AtsTestimonialCarousel from '../../../components/carousels/testimonialCarousel/testimonialCarousel';

export default {
  name: 'homeProductsCandidAts',
  props: {
  },
  components: {
    'home-products-crs-data-row': HomeProductsCrsDataRow,
    'rare-home-products-crs': RareHomeProductsCRS,
    'rare-person-quote': RarePersonQuote,
    'home-products-crs-logos': HomeProductsCrsLogos,
    'rare-comparison-table': RareComparisonTable,
    'home-products-crs-main-section': HomeProductsCrsMainSection,
    'rare-contact-form': RareContactForm,
    'rare-awards': RareAwards,
    'testimonial-carousel': AtsTestimonialCarousel,
  },
  data() {
    return {
      slides: [
        {
          quote: 'Rare has built the best social mobility measuring tool for graduate recruitment. Every year we\'ve worked with Rare has given us a deeper insight into our candidates and allowed us to take better, more informed decisions.',
          img: Mary,
          name: 'Mary Carpenter',
          position: 'Head of Recruitment',
          logo: HSF,
          id: 0,
        },
        {
          quote: 'The tool is really user-friendly and helps us find talent that we might otherwise overlook, allowing us to make better and more informed hiring decisions. The team at Rare is also always happy to chat through any questions or data that we might need.',
          img: Christina,
          name: 'Christina Gutierrez',
          position: 'Early Careers Advisor',
          logo: Dentons,
          id: 1,
        },
        {
          quote: 'The CRS has transformed our hiring process and enriched our workforce.',
          img: Skye,
          name: 'Skye Fenton-Wells',
          position: 'Early Talent Recruitment Manager',
          logo: Womble,
          id: 2,
        },
        {
          quote: 'I am a big advocate. The system is powerful, the Rare team are knowledgeable, and I have confidence in the meticulous way they revisit the algorithm as the landscape changes.',
          img: Hannah,
          name: 'Hannah Rolph',
          position: 'Associate, Head of TA and EC',
          logo: FrankKnight,
          id: 3,
        },
      ],
      tableHeaders: [
        'Feature',
        'Rare Contextual Recruitment System',
        'Contextual Recruitment Competitors',
      ],
      tableRows: [
        {
          feature: 'Low cost - sometimes given away for free by ATS providers',
          rare: false,
          competitor: true,
        },
        {
          feature: 'CIPD award winning',
          rare: true,
          competitor: false,
        },
        {
          feature: 'Market leader - 2m+ applications contextualised since launch',
          rare: true,
          competitor: false,
        },
        {
          feature: 'Platinum-level ISO27001 information security enabling safe use of sensitive personal data in decision-making',
          rare: true,
          competitor: false,
        },
        {
          feature: 'Transparent, easily explicable algorithm',
          rare: true,
          competitor: false,
        },
        {
          feature: 'Measure of outperformance at both ages <em>16</em> and <em>18</em>',
          rare: true,
          competitor: false,
        },
        {
          feature: 'Data for schools in England, Scotland, Wales <em>and</em> Northern Ireland',
          rare: true,
          competitor: false,
        },
        {
          feature: 'Industry benchmarking in product',
          rare: true,
          competitor: false,
        },
      ],
    };
  },
  created() {
  },
  destroyed() {
  },
  mounted() {
  },
  methods: {
    jumpToForm() {
      const element = document.getElementById('rare-contact-form');
      const y = element.getBoundingClientRect().top + (window.pageYOffset - 330);

      const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

      if (isIE11 === true) {
        document.getElementById('validationAnchor').scrollIntoView();
      } else {
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

@import "~@/css/global.scss";

.container-pad {
  padding-top: 95px;
}

</style>



// WEBPACK FOOTER //
// src/pages/homeProducts/homeProductsCrs/homeProductsCrs.vue